<template>
  <div id="menu">
    <div class="cabezal">
      <h1>KLASE A</h1>
      <!--<h2>YACHTS & BOATS</h2>-->
    </div>

    <router-link v-bind:to="{name: 'table'}">
      <svg class="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.999 70">
        <g id="Group_109" data-name="Group 109" transform="translate(-1790 -60)">
          <g id="Group_108" data-name="Group 108" transform="translate(1790 60)">
            <g id="Group_100" data-name="Group 100" transform="translate(0)">
              <path
                id="Path_150"
                data-name="Path 150"
                class="cls-1"
                d="M390,902.513a5.191,5.191,0,1,1,0-7.347l3.672,3.672Zm28.521,16.7-20.376-20.379,20.27-20.267h-4.473L395.909,896.6l-3.675-3.672a8.355,8.355,0,1,0,0,11.817l3.675-3.672,18.138,18.141Z"
                transform="translate(-364.199 -863.893)"
              />
              <path
                id="Path_151"
                data-name="Path 151"
                class="cls-1"
                d="M385.078,852.012a31.839,31.839,0,1,0,31.839,31.839,31.875,31.875,0,0,0-31.839-31.839m0,66.839A35,35,0,1,1,409.827,908.6a34.754,34.754,0,0,1-24.749,10.255"
                transform="translate(-350.079 -848.851)"
              />
            </g>
            <rect
              id="Rectangle_45"
              data-name="Rectangle 45"
              class="cls-1"
              width="3.161"
              height="40.646"
              transform="translate(21.999 14.678)"
            />
          </g>
        </g>
      </svg>
    </router-link>

    <div class="menu-right">
      <router-link v-bind:to="{name: 'contact'}">
        <svg
          class="icon"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 30 30"
          style="enable-background:new 0 0 30 30;"
          xml:space="preserve"
        >
          <g>
            <polygon class="st0" points="22.1,9.3 7.9,9.3 15,15.1 	" />
            <path
              class="st0"
              d="M14.6,16.3L6.8,9.9v10.7h16.3V9.9l-7.8,6.3C15.1,16.4,14.8,16.4,14.6,16.3z"
            />
            <path
              class="st0"
              d="M15,0C6.7,0,0,6.7,0,15c0,8.3,6.7,15,15,15s15-6.7,15-15C30,6.7,23.3,0,15,0z M24.3,21.2
		c0,0.3-0.3,0.6-0.6,0.6H6.2c-0.3,0-0.6-0.3-0.6-0.6V8.7c0-0.3,0.3-0.6,0.6-0.6c0,0,0,0,0,0c0,0,0,0,0,0h17.5c0,0,0,0,0,0
		c0.3,0,0.6,0.3,0.6,0.6V21.2z"
            />
          </g>
        </svg>
      </router-link>
      <a :href="instagram" target="_blank" alt="Instagram" title="Instagram">
        <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
          <path
            class="st0"
            d="M18.5,7.9c-0.9,0-1.2,0-3.5,0s-2.6,0-3.5,0C9.1,8,8,9.1,7.9,11.5c0,0.9-0.1,1.2-0.1,3.5s0,2.6,0.1,3.5
                        c0.1,2.3,1.2,3.5,3.6,3.6c0.9,0,1.2,0.1,3.5,0.1c2.3,0,2.6,0,3.5-0.1c2.4-0.1,3.5-1.2,3.6-3.6c0-0.9,0.1-1.2,0.1-3.5s0-2.6-0.1-3.5
                        C22,9.1,20.9,8,18.5,7.9z M15,19.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5S17.5,19.5,15,19.5z M19.7,11.4
                        c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1s1,0.5,1,1.1C20.7,10.9,20.3,11.4,19.7,11.4z M17.9,15c0,1.6-1.3,2.9-2.9,2.9
                        s-2.9-1.3-2.9-2.9c0-1.6,1.3-2.9,2.9-2.9S17.9,13.4,17.9,15z M15,0C6.7,0,0,6.7,0,15s6.7,15,15,15s15-6.7,15-15S23.3,0,15,0z
                         M23.7,18.6c-0.1,3.2-1.9,4.9-5.1,5.1c-0.9,0-1.2,0.1-3.6,0.1s-2.7,0-3.6-0.1c-3.2-0.1-4.9-1.9-5.1-5.1c0-0.9-0.1-1.2-0.1-3.6
                        s0-2.7,0.1-3.6c0.1-3.2,1.9-4.9,5.1-5.1c0.9,0,1.2-0.1,3.6-0.1s2.7,0,3.6,0.1c3.2,0.1,4.9,1.9,5.1,5.1c0,0.9,0.1,1.2,0.1,3.6
                        S23.7,17.7,23.7,18.6z"
          />
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "product-menu",
  computed: {
    instagram() {
      let instagram = this.$store.getters.getParameterValueByKey("instagram");
      return instagram ? instagram.value_es : "";
    }
  }
};
</script>

<style scoped>
</style>